import produce from 'immer';

import {
  CASE_CUSTOM_TILE_CREATE_FAILURE,
  CASE_CUSTOM_TILE_CREATE_REQUEST,
  CASE_CUSTOM_TILE_CREATE_SUCCESS,
  CASE_CUSTOM_TILE_EDIT_FAILURE,
  CASE_CUSTOM_TILE_EDIT_REQUEST,
  CASE_CUSTOM_TILE_EDIT_SUCCESS,
  CASE_CUSTOM_TILE_FETCH_FAILURE,
  CASE_CUSTOM_TILE_FETCH_REQUEST,
  CASE_CUSTOM_TILE_FETCH_SUCCESS,
} from '@actions/caseCustomTile';

const initialState: ICaseCustomTileStore = {
  currentCaseCustomTile: null,
  error: null,
  isFetching: false,
};

export default (state: ICaseCustomTileStore = initialState, action: any) =>
  produce(state, (draftState: ICaseCustomTileStore) => {
    switch (action.type) {
      case CASE_CUSTOM_TILE_CREATE_REQUEST:
      case CASE_CUSTOM_TILE_FETCH_REQUEST:
      case CASE_CUSTOM_TILE_EDIT_REQUEST:
        draftState.isFetching = true;

        return;

      case CASE_CUSTOM_TILE_EDIT_FAILURE:
      case CASE_CUSTOM_TILE_FETCH_FAILURE:
      case CASE_CUSTOM_TILE_CREATE_FAILURE:
        draftState.currentCaseCustomTile = null;
        draftState.isFetching = false;
        draftState.error = action.error;

        return;

      case CASE_CUSTOM_TILE_FETCH_SUCCESS:
      case CASE_CUSTOM_TILE_EDIT_SUCCESS:
      case CASE_CUSTOM_TILE_CREATE_SUCCESS:
        draftState.currentCaseCustomTile = action.response;
        draftState.isFetching = false;
        draftState.error = null;

        return;
    }
  });
